import { ZendeskCustomField, ZendeskFormField, ZendeskPriority, ZendeskTicket } from '@/types';
import { hostnameWithoutSubdomain } from '@/utils';

const hostname = global.window?.location?.hostname;
const domain = hostnameWithoutSubdomain(hostname);

const DROPZONE_ID_DEV = 'R3CYKW2BjbR4vQDIFoaS_BspTmI6HZgscJYlbAb1v5c';
const DROPZONE_ID_PROD = 'P96Fzmwna7UaxbW0Qpze3xISr3SCYq9KVMgH6FBaFJc';

export const getEditableFields = (fields: ZendeskFormField[]) =>
	fields.filter((field: ZendeskFormField) => field.editable) ?? [];

export const getFieldType = (type: string): 'textarea' | 'number' | 'tel' | 'email' | 'text' | 'select' => {
	switch (type) {
		case 'description':
			return 'textarea';
		case 'tagger':
			return 'select';
		case 'multiselect':
			return 'select';
		default:
			return 'text';
	}
};

/* SendSafely DropZone Id */
export const getDropZone = () => {
	return domain === 'fortnox.se' ? DROPZONE_ID_PROD : DROPZONE_ID_DEV;
};

export function buildZendeskTicket(formData: FormData, groupId: string, formId: string, tag?: string): ZendeskTicket {
	let customFields: ZendeskCustomField[] = [];
	formData.forEach((value, prop) => {
		if (!isNaN(Number(prop))) customFields.push({ id: Number(prop), value: String(value) });
	});

	const o: ZendeskCustomField = { id: 0, value: '' };

	// group fields by custom fields id and put values into one array
	customFields = customFields.reduce(function (r, el) {
		const id = el.id as number;
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		//@ts-ignore
		if (!o[id]) {
			// eslint-disable-next-line @typescript-eslint/ban-ts-comment
			//@ts-ignore
			o[id] = {
				id: el.id,
				value: [],
			};
			// eslint-disable-next-line @typescript-eslint/ban-ts-comment
			//@ts-ignore
			r.push(o[id]);
		}
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		//@ts-ignore
		o[id].value.push(el.value);
		return r;
	}, []);

	customFields = customFields.map((field) => {
		if (Array.isArray(field.value) && field.value.length === 1) return { id: field.id, value: field.value.toString() };
		return field;
	});

	const ticket: ZendeskTicket = {
		ticket: {
			comment: {
				body: formData.get('description') as string,
				public: true,
				uploads: null,
			},
			custom_fields: customFields,
			subject: formData.get('subject') as string,
			priority: formData.get('priority') as ZendeskPriority,
			requester: {
				name: `${formData.get('firstName')} ${formData.get('lastName')}`,
				email: formData.get('email') as string,
			},
			group_id: groupId,
			ticket_form_id: formId,
			via: {
				channel: 'mail',
			},
			tags: [tag ?? '', 'inkommit_via_hemsidan'],
		},
	};

	return ticket;
}
